import { z } from 'zod';
import { isoDateSchema, mobileSchema, objectIdSchema, timezoneSchema } from './common.js';
import { dailyMinutesSchema, goalKeySchema } from './user.js';
/**
 * A goal as it appears against a user: the stable key, the display name resolved from the
 * goals collection, and the priority the user themselves set. Priority 0 is the primary
 * goal — the one that decides which journey they are matched with.
 */
export const adminUserGoalSchema = z.object({
    key: goalKeySchema,
    name: z.string(),
    priority: z.number().int(),
});
export const adminUserResponseSchema = z.object({
    id: objectIdSchema,
    mobile: mobileSchema,
    name: z.string().nullable(),
    timezone: timezoneSchema,
    onboardingCompleted: z.boolean(),
    /** Ordered by priority, so index 0 is always the primary goal. */
    goals: z.array(adminUserGoalSchema),
    dailyMinutes: dailyMinutesSchema.nullable(),
    streakCount: z.number().int(),
    /** Account deletion is soft; a deleted account still appears here. */
    deletedAt: isoDateSchema.nullable(),
    createdAt: isoDateSchema,
});
export const listUsersQuerySchema = z.object({
    cursor: z.string().min(1).optional(),
    limit: z.coerce.number().int().min(1).max(50).default(25),
    /** Matches part of a mobile number. */
    search: z.string().trim().max(20).optional(),
    onboarded: z
        .enum(['true', 'false'])
        .optional()
        .transform((value) => (value === undefined ? undefined : value === 'true')),
});
//# sourceMappingURL=adminUser.js.map